<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>订单进度</el-breadcrumb-item>
        <el-breadcrumb-item>数据列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">数据列表</h2>
        </div>
        <!--    <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleTaskCreate"
          >添加任务</el-button>
        </div> -->
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="用户信息"
                      prop="name">
          <el-input v-model="query.user"
                    placeholder="输入用户昵称/姓名/手机号"
                    @input="fetchGroupList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="订单编号"
                      prop="code">
          <el-input v-model="query.order_no"
                    placeholder="输入订单编号"
                    @input="fetchGroupList(true)"
                    clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">数据列表</h3>
        <el-form label-width="70px"
                 size="small">
          <el-form-item style="">
            <el-radio-group v-model="query.is_all"
                            @change="fetchGroupList()">
              <el-radio-button :label="1">
                是
              </el-radio-button>
              <el-radio-button :label="0">
                否
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="order_id"
                           label="订单ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="order_no"
                           label="订单编号"
                           width="180"
                           align="center">
          </el-table-column>
          <el-table-column prop="goods_name"
                           label="商品名称"
                           min-width="300"
                           align="center">
          </el-table-column>
          <el-table-column prop="uid"
                           label="用户ID"
                           width="100"
                           align="center">
          </el-table-column>
          <el-table-column prop="nickname"
                           label="用户名称"
                           width="100"
                           align="center">
          </el-table-column>
          <el-table-column label="订单状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                      type="success"
                      v-if="scope.row._delete==1&&scope.row.run_step_no==100">执行成功</el-tag>
              <div v-else>
                <el-tag size="mini"
                        v-if="scope.row.status==0">待执行</el-tag>
                <el-tag size="mini"
                        type="danger"
                        v-else-if="scope.row.status==2">执行失败</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="任务进度名称"
                           width="180"
                           align="center">
            <template slot-scope="scope">
              <span>{{ run_step_noRender(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="执行次数"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.retry_count}}次
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="180"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToEdit(scope.row)"
                         :disabled="scope.row.status!=2">重新执行</el-button>
              <el-button class="remove-text-button"
                         size="mini"
                         type="text"
                         @click="handleToGroupRemove(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="handleToEdit(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      重新执行
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom:6px;"><span @click="handleToGroupRemove(scope.row, scope.$index)"
                          style="font-size:16px;color: #F56C6C;">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  doneTasklist,
  editorderdoneTask,
  deleteorderdoneTask,
} from '@/api/index.js'

export default {
  components: {},
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        name: '',
        code: '',
        type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        is_all: 0,
      },
      pageTotal: 10,
      filter: {
        types: [
          { label: '全部', value: '' },
          { label: '奖励', value: '1' },
          { label: '消耗', value: '2' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      dialogFormVisible: false,
    }
  },
  created() {
    this.parseQuery()
    this.fetchGroupList()
  },
  methods: {
    fetchGroupList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      doneTasklist(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchGroupList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchGroupList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchGroupList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchGroupList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: '正常',
        2: '关闭',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },

    handleTaskCreate() {
      this.createDialog = true
    },

    handleToEdit(row) {
      this.$confirm('确定要重新执行吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          let query = {
            id: row.id,
            status: 0,
            retry_count: 0,
            _delete: 0,
          }
          editorderdoneTask(query).then((res) => {
            this.$message.success(`操作成功`)
            this.fetchGroupList()
          })
        })
        .catch(() => {})
    },
    handleToGroupRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          deleteorderdoneTask({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchGroupList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    // 订单状态渲染
    run_step_noRender(row) {
      const obj = {
        1: '订单状态修改',
        2: '短书同步',
        3: '后台开课通知',
        4: '拼团成功短信通知',
        5: '拼团成功微信公众号通知',
      }
      return obj[row.run_step_no] || ''
    },
  },
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
